"use client";

import { c as _c } from "react/compiler-runtime";
import NumberFlow, { type Format } from "@number-flow/react";
import type { ComponentProps } from "react";
type NumberFlowProps = ComponentProps<typeof NumberFlow>;
interface AnimatedNumberProps extends Omit<NumberFlowProps, "value" | "format" | "locales"> {
  value: number;
  format?: Format;
}

/** Ticking numeral. en-US, respects prefers-reduced-motion (NumberFlow default). */
export function AnimatedNumber(t0) {
  const $ = _c(8);
  let format;
  let rest;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      format,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = format;
    $[2] = rest;
    $[3] = value;
  } else {
    format = $[1];
    rest = $[2];
    value = $[3];
  }
  let t1;
  if ($[4] !== format || $[5] !== rest || $[6] !== value) {
    t1 = <NumberFlow value={value} locales="en-US" format={format} {...rest} />;
    $[4] = format;
    $[5] = rest;
    $[6] = value;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
const USD_FORMAT: Format = {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};

/** Mirrors `formatCurrency` from pool-analysis-ui ($ + 2 decimals) — keep in sync. */
export function AnimatedCurrency(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <AnimatedNumber format={USD_FORMAT} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function AnimatedInteger(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maximumFractionDigits: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <AnimatedNumber format={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}